module.exports = __webpack_public_path__ + "img/monettique.ee10e411.png";